export enum FeatureToggle {
  pageBuilderSingleRetailer = 'rt_pagebuilder_single_retailer',
  brandingV2 = 'rt_ipp_branding_v2',
}
